<template><SimpleModuleDashboard :module-id="Modules.REMITOS_COMPRAS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'purchaseRemits', reference: 'purchaseRemits', route: 'PurchaseStaffPurchaseRemits', tone: 'primary' },
] }) }
</script>
